import * as React from "react";
import { Stack, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { colors } from "../../styles/constants";
import { FormField } from "../../components/molecules/FormField";
import { localSession } from "@/utils/session";
import { updateAdditionalServices } from "@/services/api/caseApi";

export const ThirdPartyMarketing: React.FC<{ thirdPartyMarketing?: boolean }> = ({
  thirdPartyMarketing = false,
}) => {
  const session = localSession();
  const [marketingConsent, setMarketingConsent] = React.useState<boolean>(thirdPartyMarketing);

  function handleConsentChange(value: boolean) {
    updateAdditionalServices({
      caseId: session?.caseId,
      signature: session?.signature,
      record: { thirdPartyMarketing: value },
    }).then(
      () => {
        setMarketingConsent(value);
        console.log("Third party marketing consent updated");
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  return (
    <FormField>
      <Stack
        sx={{
          maxWidth: "100%",
          padding: "20px 24px",
          backgroundColor: "rgba(242, 242, 242, 0.4)",
          borderRadius: "8px",
          borderColor: colors.lightGrey,
          borderWidth: 1,
          borderStyle: "solid",
        }}
      >
        <FormControlLabel
          sx={{
            margin: 0,
            alignItems: "flex-start",
            "& .MuiCheckbox-root": {
              padding: "0 12px 0 0",
              marginTop: "-2px",
            },
          }}
          control={
            <Checkbox
              checked={marketingConsent}
              onChange={(e) => handleConsentChange(e.target.checked)}
              color="primary"
              sx={{
                color: colors.lightGrey,
                "&.Mui-checked": {
                  color: colors.accentTeal,
                },
              }}
            />
          }
          label={
            <Typography
              variant="body1"
              sx={{
                color: colors.bodyText,
                lineHeight: 1.6,
                fontSize: "0.9375rem",
                letterSpacing: "0.01em",
                fontWeight: 400,
              }}
            >
              I wish to opt-in to receive marketing communications from our affiliate company,
              Estate Resolution Technologies (UK) Ltd., for products/services in relation handling
              the estate of a deceased individual, as those might be of interest to me. I understand
              I can withdraw my consent at any time.
            </Typography>
          }
        />
      </Stack>
    </FormField>
  );
};
